export default function registerPromiseWorker(callback) {
    self.addEventListener('message', async (e) => {
        const payload = e.data;
        const messageId = payload[0];
        const message = payload[1];
        try {
            const transferList = [];
            const callbackResult = await callback(message, (t) => transferList.push(t));
            self.postMessage([messageId, null, callbackResult], transferList.length ? { transfer: transferList } : undefined);
        }
        catch (error) {
            self.postMessage([messageId, {
                    message: error.message
                }]);
        }
    });
}
